import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, BatteryWarning, BrainCircuit } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const painPoints = [{
    icon: Clock,
    text: 'Preparar clases'
  }, {
    icon: BrainCircuit,
    text: 'Improvisar'
  }, {
    icon: AlertCircle,
    text: 'Corregir y Evaluar'
  }, {
    icon: BatteryWarning,
    text: 'Contener y Motivar'
  }];
  return <section className="py-20 bg-orange-50" data-id="element-94">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-96">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-97">
            Si sos docente de inglés y sentís que cada semana vivís corriendo...
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-98">
            Improvisando y agotada, no es que seas mala docente. No es que te
            falte vocación. No es que no sepas enseñar.
          </p>

          <div className="bg-white px-8 py-6 rounded-2xl shadow-md border border-orange-100 inline-block transform -rotate-1" data-id="element-99">
            <p className="text-2xl font-bold text-orange-600" data-id="element-100">
              👉 Te falta un sistema que te sostenga.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-102">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-103">
              Porque hoy, planificar no es planificar. Es sobrevivir.
            </h3>
            <p className="text-lg text-gray-700" data-id="element-104">
              Buscás actividades a último momento. Imprimís apurada. Explicás
              sin estructura. Te llevás trabajo todos los días.
            </p>
            <p className="text-lg text-gray-700" data-id="element-105">
              Y entrás al aula con una sensación que no te deja tranquila:
            </p>
            <blockquote className="border-l-4 border-orange-500 pl-6 py-2 italic text-gray-800 text-xl bg-white/50 rounded-r-lg" data-id="element-106">
              "Ojalá esto salga bien..."
            </blockquote>
            <p className="font-bold text-gray-900 text-lg pt-2" data-id="element-107">
              No estás cansada. Estás sobrecargada. <br data-id="element-108" />
              No estás fallando. Estás enseñando sin un sistema que te proteja.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-109">
            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-100 rounded-full filter blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-110"></div>

            <h3 className="text-xl font-bold text-gray-900 mb-8 text-center uppercase tracking-wider" data-id="element-111">
              El problema real no es tuyo
            </h3>
            <p className="text-gray-600 mb-8 text-center text-lg" data-id="element-112">
              El sistema educativo te pide que hagas el trabajo de 3 personas…
              con el tiempo de una.
            </p>

            <div className="grid grid-cols-2 gap-4" data-id="element-113">
              {painPoints.map((point, idx) => <div key={idx} className="flex flex-col items-center p-4 bg-gray-50 rounded-xl hover:bg-orange-50 transition-colors duration-300" data-id="element-114">
                  <point.icon className="w-8 h-8 text-orange-500 mb-3" data-id="element-115" />
                  <span className="text-sm font-bold text-gray-700 text-center" data-id="element-116">
                    {point.text}
                  </span>
                </div>)}
            </div>

            <p className="mt-8 text-center text-gray-500 text-sm italic" data-id="element-117">
              Y ahí empieza el desgaste invisible: mental, emocional,
              silencioso.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-118">
          <CTAButton text="NECESITO UNA SOLUCIÓN" data-id="element-119" />
        </div>
      </div>
    </section>;
}